import {Injectable} from '@angular/core';
import {Subject, Observable, MonoTypeOperatorFunction, defer} from 'rxjs';
import {finalize} from 'rxjs/operators';

export type PreloaderType = 'RoundSpinner' | 'LinearSpinner' | 'None';

export class PreloaderState {
    type: PreloaderType = 'LinearSpinner';
    preloaderName?: string = 'root';
    cancelEvent?: () => void;
}

export interface PreloaderConfig {
    name?: string;
    type?: PreloaderType;
}

export function withPreloader<T>(service: MxPreloaderService, config?: PreloaderConfig): MonoTypeOperatorFunction<T> {
    return source$ =>
        defer(() => {
            service.show(config);
            return source$.pipe(finalize(() => service.hide(config)));
        });
}

@Injectable({
    providedIn: 'root'
})
export class MxPreloaderService {

    private _preloaderState$$: Subject<PreloaderState> = new Subject<PreloaderState>();

    getPreloaderState(): Observable<PreloaderState> {
        return this._preloaderState$$;
    }

    show(config?: PreloaderConfig, cancelEvent?: () => void): void {
        let state = new PreloaderState();
        if (config) {
            state.type = config.type ? config.type : state.type;
            state.preloaderName = config.name ? config.name : state.preloaderName;
        }
        state.cancelEvent = cancelEvent;
        this._preloaderState$$.next(state);
    }

    hide(config?: PreloaderConfig): void {
        let state = new PreloaderState();
        if (config && config.name) {
            state.preloaderName = config.name;
        }
        state.type = 'None';
        this._preloaderState$$.next(state);
    }
}
